import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-kyc-thankyou',
  templateUrl: './kyc-thankyou.component.html',
  styleUrls: ['./kyc-thankyou.component.scss']
})
export class UserKycThankyouPageComponent implements OnInit {
  availableClasses: string[] = ["dark", "Thankyou", "colorful"];
  currentClassIdx: number = 0;

  bodyClass: string;
  constructor() {
  
    this.bodyClass = this.availableClasses[this.currentClassIdx];
    this.changeBodyClass();
    
  }
  changeBodyClass() {
    // get html body element
    const bodyElement = document.body;

    if (bodyElement) {


      this.currentClassIdx = this.getNextClassIdx();
      const nextClass = this.availableClasses[this.currentClassIdx];
      const activeClass = this.availableClasses[this.getPrevClassIdx()];

      // remove existing class (needed if theme is being changed)
      bodyElement.classList.remove(activeClass);
      // add next theme class
      bodyElement.classList.add(nextClass);

      this.bodyClass = nextClass;
    }
  }

  getPrevClassIdx(): number {
    return this.currentClassIdx === 0
      ? this.availableClasses.length - 1
      : this.currentClassIdx - 1;
  }

  getNextClassIdx(): number {
    return this.currentClassIdx === this.availableClasses.length - 1
      ? 0
      : this.currentClassIdx + 1;
  }
  
  ngOnInit(): void {
  }

}
